<div class="modal-header">
    <h5 class="modal-title">{{ modalTitle }}</h5>
</div>
<form [formGroup]="codeForm">
    <div class="modal-body row mx-auto" style="width: 100%;">
        <div class="col-4 my-2 position-relative">
            <mdb-form-control class="custom-shadow position-relative">
                <input
                    mdbValidate
                    mdbInput
                    type="text"
                    id="serial"
                    class="form-control"
                    required
                    minlength="5"
                    formControlName="serial"
                    placeholder="Serial"
                />
                <label mdbLabel class="form-label" for="serial">Serial</label>
            </mdb-form-control>
            <div *ngIf="codeForm?.get('serial')?.touched && codeForm?.get('serial')?.errors?.['required']" class="floating-alert">
                <span class="error-icon me-2">⚠️</span>Campo requerido
            </div>
            <div *ngIf="codeForm?.get('serial')?.errors?.['minlength']" class="floating-alert">
                <span class="error-icon me-2">⚠️</span>Mínimo 5 caracteres
            </div>
        </div>
        <div class="col-4 my-2">
            <mdb-form-control class="custom-shadow position-relative">
                <input
                    mdbValidate
                    mdbInput
                    type="text"
                    id="description"
                    class="form-control"
                    required
                    minlength="5"
                    formControlName="description"
                />
                <label mdbLabel class="form-label" for="description">Descripción</label>
            </mdb-form-control>
            <div *ngIf="codeForm?.get('description')?.touched && codeForm?.get('description')?.errors?.['required']" class="floating-alert">
                <span class="error-icon me-2">⚠️</span>Campo requerido
            </div>
            <div *ngIf="codeForm?.get('description')?.errors?.['minlength']" class="floating-alert">
                <span class="error-icon me-2">⚠️</span>Mínimo 5 caracteres
            </div>
        </div>
        <div class="col-4 my-2">
            <mdb-form-control class="custom-shadow position-relative">
                <input
                    mdbValidate
                    mdbInput
                    type="text"
                    id="foreign"
                    class="form-control"
                    required
                    formControlName="foreign"
                />
                <label mdbLabel class="form-label" for="foreign">Extranjera</label>
            </mdb-form-control>
            <div *ngIf="codeForm?.get('foreign')?.touched && codeForm?.get('foreign')?.errors?.['required']" class="floating-alert">
                <span class="error-icon me-2">⚠️</span>Campo requerido
            </div>
        </div>
    </div>
    <div class="modal-body row mx-auto" style="width: 100%;">
        <div class="col-4 my-2">
            <mdb-form-control class="custom-shadow position-relative">
                <input
                    mdbValidate
                    mdbInput
                    type="text"
                    id="un"
                    class="form-control"
                    required
                    formControlName="un"
                />
                <label mdbLabel class="form-label" for="un">Un</label>
            </mdb-form-control>
            <div *ngIf="codeForm?.get('un')?.touched && codeForm?.get('un')?.errors?.['required']" class="floating-alert">
                <span class="error-icon me-2">⚠️</span>Campo requerido
            </div>
        </div>
        <div class="col-4 my-2">
            <mdb-form-control class="custom-shadow position-relative">
                <input
                    mdbValidate
                    mdbInput
                    type="text"
                    id="unEst"
                    class="form-control"
                    required
                    formControlName="un_est"
                />
                <label mdbLabel class="form-label" for="unEst">Un Est</label>
            </mdb-form-control>
            <div *ngIf="codeForm?.get('un_est')?.touched && codeForm?.get('un_est')?.errors?.['required']" class="floating-alert">
                <span class="error-icon me-2">⚠️</span>Campo requerido
            </div>
        </div>
        <div class="col-4 my-2">
            <mdb-form-control class="custom-shadow position-relative">
                <input
                    mdbValidate
                    mdbInput
                    type="text"
                    id="unFor"
                    class="form-control"
                    required
                    formControlName="un_for"
                />
                <label mdbLabel class="form-label" for="unFor">Un For</label>
            </mdb-form-control>
            <div *ngIf="codeForm?.get('un_for')?.touched && codeForm?.get('un_for')?.errors?.['required']" class="floating-alert">
                <span class="error-icon me-2">⚠️</span>Campo requerido
            </div>
        </div>
    </div>
    <div class="modal-body row mx-auto" style="width: 100%;">
        <div class="col-4 my-2 ">
            <mdb-form-control class="custom-shadow position-relative">
                <input
                    mdbValidate
                    mdbInput
                    type="text"
                    id="factor"
                    class="form-control"
                    required
                    formControlName="factor"
                />
                <label mdbLabel class="form-label" for="factor">Factor</label>
            </mdb-form-control>
            <div *ngIf="codeForm?.get('factor')?.touched && codeForm?.get('factor')?.errors?.['required']" class="floating-alert">
                <span class="error-icon me-2">⚠️</span>Campo requerido
            </div>
        </div>
        <div class="col-4 my-2 ">
            <mdb-form-control class="custom-shadow position-relative">
                <input
                    mdbValidate
                    mdbInput
                    type="text"
                    id="skuManagement"
                    class="form-control"
                    required
                    formControlName="sku_management"
                />
                <label mdbLabel class="form-label" for="skuManagement">Gestión SKU</label>
            </mdb-form-control>
            <div *ngIf="codeForm?.get('sku_management')?.touched && codeForm?.get('sku_management')?.errors?.['required']" class="floating-alert">
                <span class="error-icon me-2">⚠️</span>Campo requerido
            </div>
        </div>
    </div>
</form>
<div class="modal-footer">
    <button
        type="button"
        class="shadow-0 btn btn-md btn-outline-primary"
        (click)="modalRef.close()"
        >
        Cancelar
    </button>

    <button 
        [disabled]="codeForm.invalid"
        type="button"
        class="shadow-0 btn btn-md btn-primary"
        (click)="InsertOrUpdate()"
        [textContent]="edit === 0 ? 'Guardar' : 'Editar'"
        >
    </button>
</div>

<mdb-loading [show]="loading" [fullscreen]="true">
    <div class="loading-spinner">
        <div class="spinner-border loading-icon" role="status"></div>
        <span class="loading-text">Cargando datos...</span>
    </div>
</mdb-loading>